"use client";

import { api, VerifyPermissionRequestFunction } from "@/api";
import { userStore } from "@/store/user";
import { autorun } from "mobx";
import { useEffect, useRef } from "react";

const INTERVAL_MS = 10 * 60 * 1000;

export function useVerify() {
  const intervalRef = useRef<number | null>(null);
  const stopAutorunRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    const verify = async () => {
      try {
        const res = await api.invitations.verifyPermission({
          function: VerifyPermissionRequestFunction.VID_MUSE,
        });
        if (res.data?.success !== true) {
          window.location.href = "/auth/logout";
        }
      } catch (e) {
        // Ignore error
        console.error(e);
      }
    };

    const startPolling = () => {
      intervalRef.current = window.setInterval(verify, INTERVAL_MS);
    };

    const stopPolling = () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };

    // React to login state changes
    stopAutorunRef.current = autorun(() => {
      const isLogin = userStore.isLogin;
      if (isLogin) {
        if (!intervalRef.current) {
          startPolling();
        }
      } else {
        stopPolling();
      }
    });

    return () => {
      stopPolling();
      if (stopAutorunRef.current) {
        stopAutorunRef.current();
        stopAutorunRef.current = null;
      }
    };
  }, []);
}
